import React, {useState, useEffect, useRef, useContext} from 'react';
import {ProjectsContext} from "../../App";
import { loadDataWithCache } from '../../utils';
import './style.scss';

/**
 * IntroVideo component that displays a full-screen video on app load
 * The video disappears when it finishes playing or when clicked with a fade-out effect
 */
const IntroVideo = () => {
  const {imagesCache, setImagesCache} = useContext(ProjectsContext);
  const [video, setVideo] = useState(null);
  const videoRef = useRef(null);

  useEffect(() => {
    const fetchIntroVideo = async () => {
      try {
        const videos = await loadDataWithCache('12sec', imagesCache, setImagesCache,'video');

        if (videos && videos.length > 0) {
          // Select a random video from the array
          const randomIndex = Math.floor(Math.random() * videos.length);
          setVideo(videos[randomIndex]);
        }
      } catch (error) {
        console.error('Failed to load intro video:', error);
      }
    };

    fetchIntroVideo();
  }, [imagesCache, setImagesCache]);

  if (!video) return null;

  // Format Cloudinary URL for video
  const videoUrl = `https://res.cloudinary.com/dlkzchunj/video/upload/${video.public_id}.${video.format || 'mp4'}`;

  return (
    <div className='intro-video-overlay'>
      <video
        ref={videoRef}
        className="intro-video"
        src={videoUrl}
        autoPlay
        muted
        playsInline
        loop
      />
    </div>
  );
};

export default IntroVideo;
